import React, { Component } from 'react';
import { PhoneIcon, ShoppingBagIcon, ShieldCheckIcon, LaptopIcon, ShoppingCartIcon, BarChartIcon, ArrowRightIcon } from 'lucide-react';
export function TradeInSolutions() {
  return <section id="solutions" className="bg-white dark:bg-black text-gray-900 dark:text-white py-20" data-id="element-968">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-969">
        <div className="text-center mb-12" data-id="element-970">
          <div className="inline-flex items-center px-4 py-1 bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green rounded-full text-sm font-medium mb-4" data-id="element-971">
            Complete Solutions
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" data-id="element-972">
            Comprehensive Trade-In{' '}
            <span className="bg-gradient-to-r from-blue-600 to-blue-400 dark:from-brand-green dark:to-brand-green/60 bg-clip-text text-transparent" data-id="element-973">
              Solutions
            </span>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-2xl mx-auto" data-id="element-974">
            End-to-end tools and services for every stage of the device
            lifecycle, from assessment to resale.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-975">
          {[{
          href: '#consumer-trade-in',
          icon: <PhoneIcon className="h-6 w-6" data-id="element-976" />,
          title: 'Consumer Trade-In',
          description: 'Get instant quotes for your used devices with our AI-powered assessment technology',
          features: ['Instant quotes', 'AI assessment', 'Secure payment']
        }, {
          href: '#self-service',
          icon: <ShoppingBagIcon className="h-6 w-6" data-id="element-977" />,
          title: 'Self-Service Kiosks',
          description: 'In-store kiosk systems for automated device assessment and instant trade-in credit',
          features: ['24/7 availability', 'Instant credit', 'Easy setup']
        }, {
          href: '#ai-diagnostics',
          icon: <ShieldCheckIcon className="h-6 w-6" data-id="element-978" />,
          title: 'AI Diagnostics',
          description: 'Advanced visual and functional diagnostics to accurately assess device condition',
          features: ['Visual inspection', 'Component testing', 'IMEI check']
        }, {
          href: '#business-platform',
          icon: <LaptopIcon className="h-6 w-6" data-id="element-979" />,
          title: 'Business Platform',
          description: 'Comprehensive tools for retailers and carriers to manage trade-in programs',
          features: ['Analytics', 'Inventory management', 'Reporting']
        }, {
          href: '#wholesale-marketplace',
          icon: <ShoppingCartIcon className="h-6 w-6" data-id="element-980" />,
          title: 'Wholesale Market',
          description: 'Connect with verified buyers and sellers in our global device marketplace',
          features: ['Verified buyers', 'Secure trades', 'Global reach']
        }, {
          href: '#auctions',
          icon: <BarChartIcon className="h-6 w-6" data-id="element-981" />,
          title: 'Auction Platform',
          description: 'Maximize device value through competitive bidding in our auction environment',
          features: ['Live bidding', 'Bulk lots', 'Market insights']
        }].map((item, index) => <a key={index} href={item.href} className="group bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-800 p-6 rounded-lg transition-all duration-300 hover:scale-102 hover:shadow-xl" data-id="element-982">
              <div className="flex items-center mb-4" data-id="element-983">
                <div className="w-12 h-12 bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green rounded-lg flex items-center justify-center mr-4 group-hover:scale-110 transition-transform" data-id="element-984">
                  {item.icon}
                </div>
                <h3 className="text-lg font-semibold dark:text-white" data-id="element-985">
                  {item.title}
                </h3>
              </div>
              <p className="text-gray-600 dark:text-gray-400 text-sm mb-4" data-id="element-986">
                {item.description}
              </p>
              <div className="space-y-2" data-id="element-987">
                {item.features.map((feature, featureIndex) => <div key={featureIndex} className="flex items-center text-sm text-gray-500 dark:text-gray-400" data-id="element-988">
                    <div className="w-1.5 h-1.5 rounded-full bg-blue-500 dark:bg-brand-green mr-2" data-id="element-989"></div>
                    {feature}
                  </div>)}
              </div>
              <div className="mt-4 flex items-center text-blue-600 dark:text-brand-green text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-990">
                Learn more
                <ArrowRightIcon className="h-4 w-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-991" />
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}